import { Toolbar, Typography } from "@mui/material";
import { theme } from "../../../../../theme";
import { EnhancedTableToolbarProps } from "./interfaces";

const EnhancedTableToolbar = (props: EnhancedTableToolbarProps) => {
  const { nameCrew, title } = props;
  return (
    <Toolbar
      sx={{
        display: "flex",
        justifyContent: "start",
        background: theme.palette.primary.main,
      }}
      className="crew-table-header"
    >
      <Typography
        variant="h3"
        component="p"
        sx={{
          color: "white",
        }}
      >
        {!title ? nameCrew : ""}
      </Typography>
    </Toolbar>
  );
};

export default EnhancedTableToolbar;
